import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../api/client.js';

const SuperAdminAuthContext = createContext(null);

export function SuperAdminAuthProvider({ children }) {
  const [state, setState] = useState({ status: 'loading', identity: null });

  const refresh = useCallback(async () => {
    try {
      const identity = await api.get('/api/super-admin/auth/me');
      setState({ status: 'authenticated', identity });
    } catch {
      setState({ status: 'anonymous', identity: null });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const identity = await api.post('/api/super-admin/auth/login', { email, password });
    setState({ status: 'authenticated', identity });
  }, []);

  const logout = useCallback(async () => {
    await api.post('/api/super-admin/auth/logout');
    setState({ status: 'anonymous', identity: null });
  }, []);

  return (
    <SuperAdminAuthContext.Provider value={{ ...state, login, logout, refresh }}>{children}</SuperAdminAuthContext.Provider>
  );
}

export function useSuperAdminAuth() {
  const ctx = useContext(SuperAdminAuthContext);
  if (!ctx) throw new Error('useSuperAdminAuth must be used within SuperAdminAuthProvider');
  return ctx;
}
